import userService from '../services/user'
import { createSlice } from '@reduxjs/toolkit'

import { setSuccessNotification, setErrorNotification } from './notificationReducer'

const initialState = {
    results: [],
    count: 0,
    next: null,
    previous: null,
    total_pages: 1,
    current_page: 1,
    loading: false,
}

const userSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        setUsers(state, action) {
            return action.payload
        },
        setLoading(state, action) {
            state.loading = action.payload
        },
        changeUsers(state, action) {
            if (!state.results) return state
            state.results = state.results.map(user => user.id === action.payload.id ? action.payload : user)
        }
    }
})

export const { setUsers, setLoading, changeUsers } = userSlice.actions

// Last-issued-wins (issue #407): Manage Admin's debounced filter and pager can have
// several retrieves in flight, and without this the slowest response, not the newest
// request, decided what the table showed.
let latestUsersRequest = 0

export const initializeUsers = (query = '', page = 1) => {
    return async dispatch => {
        const requestId = ++latestUsersRequest
        try {
            dispatch(setLoading(true))
            const data = await userService.retrieve(query, page)
            if (requestId !== latestUsersRequest) return
            dispatch(setUsers({ ...data, loading: false }))
        } catch {
            if (requestId !== latestUsersRequest) return // a superseded failure must not toast or clear the newer request's spinner
            dispatch(setErrorNotification('Error retrieving users'))
            dispatch(setLoading(false))
        }
    }
}

export const updateUser = (data) => {
    return async dispatch => {
        try {
            const user = await userService.update(data.id, data)
            dispatch(changeUsers(user))
            dispatch(setSuccessNotification('User updated'))
        } catch {
            dispatch(setErrorNotification('Error updating user'))
        }
    }
}

export default userSlice.reducer
